import { DOMAINS } from '../../../../constants';

/**
 * Resolve landing page domain
 * @param {string} lang Language, eg: en or de.
 * @param {string} domain Domain, eg: fiverr or business.
 * @returns {string} Landing page
 */
export const resolveLandingPage = (lang, domain) => {
    const isEng = lang === 'en';
    const host = [isEng ? '' : lang, domain === DOMAINS.BUSINESS ? 'business' : '', 'fiverr.com']
        .filter((value) => value)
        .join('.');

    return `https://${host}`;
};
